import { env } from '../../../env';

export const saveLinkForOldBackend = `${env.REACT_APP_API_URL_DEV}/spec/old-dot/specialist/profile`;
